/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import FileUploaderPluginS3 from 'DesignSystem/FileUploaderPluginS3/react'
import FileUploaderProvider from 'DesignSystem/FileUploaderProvider/react'
import GoogleTagManager from 'DesignSystem/GoogleTagManager/react'
import Questions from './Questions/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Widget/Content",
  container
  
}) {
let flowShortcutsIdValueData = fromData.useDataValue({ viewPath,
context: 'flow_shortcuts',
path: 'id',
})
let authAccessTokenDataLeadIdValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.lead_id',
})
let aggregateData = fromHelpers.getDataLayer(flowShortcutsIdValueData, authAccessTokenDataLeadIdValueData)
let constantData = 'companies/'
let authAccessTokenDataPcidValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.pcid',
})
let constantData1 = '/leads/'
let authAccessTokenDataLeadIdValueData1 = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'access_token_data.lead_id',
})
let aggregateData1 = fromAggregate.joinNoSpace(constantData, authAccessTokenDataPcidValueData, constantData1, authAccessTokenDataLeadIdValueData1)
let flowShortcutsBackgroundColorValueData = fromData.useDataValue({ viewPath,
context: 'flow_shortcuts',
path: 'backgroundColor',
})
let flowShortcutsIsShrunkValueData = fromData.useDataValue({ viewPath,
context: 'flow_shortcuts',
path: 'isShrunk',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<GoogleTagManager
  viewPath={`${viewPath}/GoogleTagManager`}
 data="flow_shortcuts.id"
 data="auth.access_token_data.lead_id"
 aggregate="helpers.js getDataLayer"
 dataLayer={aggregateData}
/>
<FileUploaderProvider
  viewPath={`${viewPath}/FileUploaderProvider`}
>
{childProps => (
<React.Fragment>
<FileUploaderPluginS3
{...childProps}
  viewPath={`${viewPath}/FileUploaderPluginS3`}
 data="'companies/'"
 data="auth.access_token_data.pcid"
 data="'/leads/'"
 data="auth.access_token_data.lead_id"
 aggregate="/Simple/Data/aggregate.js joinNoSpace"
 prefix={aggregateData1}
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 ref={container}
 style={{'--bc-5-Z1Yf8zk': flowShortcutsBackgroundColorValueData,'--fg-1-Z1Yf8zk': flowShortcutsIsShrunkValueData ? 0 : 1,'--fs-2-Z1Yf8zk': flowShortcutsIsShrunkValueData ? 0 : 1,'--pt-3-Z1Yf8zk': flowShortcutsIsShrunkValueData ? typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM : "0px",'--pb-4-Z1Yf8zk': flowShortcutsIsShrunkValueData ? typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<Questions
  viewPath={`${viewPath}/Questions`}
/>
</div>
</React.Fragment>
)}
</FileUploaderProvider>
{children}
</React.Fragment>)
}